<!-- pouzivame jeden component (tento) pre kazde volanie controlsu (input, select, textarea, ...) -->
<div
  [ngClass]="{'mb-1': !zobrazitCopyButton && !getVysvetlivka()}">

  <div class="d-flex flex-row justify-content-between">

    <div class="text-justify" [ngClass]="{'pt-1': zobrazitCopyButton || getVysvetlivka()}">
      {{getKodAPopis()}}
    </div>

    <div class="d-flex flex-row ms-2">

      <!-- SWAPOVACI BUTTON -->
      <!-- <button *ngIf="zobrazitSwapButton"
        style="margin-top: -13px;"
        [ngStyle]="{'margin-right': getVysvetlivka() ? '-6px' : '2px'}"
        mat-icon-button
        type="button"
        (click)="presunPolozky()"
        aria-label="Kopírovať text"
        [matTooltip]="getKopirovaciButtonTooltip()">
        <mat-icon>swap_vert</mat-icon>
      </button> -->


      <!-- KOPIROVACI BUTTON -->
      <button *ngIf="zobrazitCopyButton"
        style="margin-top: -13px;"
        [ngStyle]="{'margin-right': getVysvetlivka() ? '-6px' : '2px'}"
        mat-icon-button
        type="button"
        (click)="skopirovatTextdoOstatnychJazykov()"
        aria-label="Kopírovať text"
        [matTooltip]="getKopirovaciButtonTooltip()">
        <mat-icon>content_copy</mat-icon>
      </button>

      <!-- VYSVETLIVKA -->
      <!-- OTAZNIK button -->
      <button
        style="margin-top: -13px; margin-right: 2px;"
        *ngIf="getVysvetlivka()"
        mat-icon-button
        type="button"
        (click)="zobrazitHelpText = !zobrazitHelpText"
        aria-label="Help button - otaznik"
        [matTooltip]="getVysvetlivka()">
        <mat-icon class="help-icon">help</mat-icon>
      </button>

      <span [ngClass]="{'ps-2' : !zobrazitCopyButton && !getVysvetlivka()}">{{kodJazyk}}</span>

    </div>

  </div>

  <div *ngIf="getDoplnPopisCely()" class="px-4 py-1 text-justify" style="white-space: pre-line;">
    {{getDoplnPopisCely()}}
  </div>

  <div *ngIf="zobrazitHelpText && getVysvetlivka()"
    class="vysvetlivka">
    {{getVysvetlivka()}}
  </div>

</div>
